export type PostCallSurveyStatus = 'pending' | 'processing' | 'sent' | 'skipped' | 'failed';

/** What welby-micro-service decided for a registered call's NPS survey. */
export interface PostCallSurveyOutcome {
  status: PostCallSurveyStatus;
  reason?: string;
  channel?: 'sms' | 'email';
}

/** Statuses the backend will not change any more. */
export const POST_CALL_SURVEY_SETTLED_STATUSES: readonly PostCallSurveyStatus[] = ['sent', 'skipped', 'failed'];

/** Retries of the registration: it is create-only on the backend, so repeating it is safe. */
export const POST_CALL_SURVEY_REGISTER_RETRIES = 2;
export const POST_CALL_SURVEY_REGISTER_RETRY_DELAY_MS = 1000;

/**
 * After the hang-up the backend needs a few seconds — the end-of-call report travels Twilio → markus →
 * welby-micro-service — so the outcome is asked for from 2 s on, every 2 s, up to 8 times (~16 s). A call
 * whose report never arrived by then is treated as not surveyed, and the manual survey is offered.
 */
export const POST_CALL_SURVEY_OUTCOME_FIRST_CHECK_MS = 2000;
export const POST_CALL_SURVEY_OUTCOME_INTERVAL_MS = 2000;
export const POST_CALL_SURVEY_OUTCOME_CHECKS = 8;
/** A check that hangs is given up on, so the next one still runs. */
export const POST_CALL_SURVEY_OUTCOME_REQUEST_TIMEOUT_MS = 5000;
